// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRecordTaxYearChangeCreateDto
 */
export interface IRecordTaxYearChangeCreateDto {
    /**
     * 
     * @type {number}
     * @memberof IRecordTaxYearChangeCreateDto
     */
    record_id: number;
    /**
     * 
     * @type {number}
     * @memberof IRecordTaxYearChangeCreateDto
     */
    new_tax_year: number;
}

/**
 * Check if a given object implements the IRecordTaxYearChangeCreateDto interface.
 */
export function instanceOfIRecordTaxYearChangeCreateDto(value: object): value is IRecordTaxYearChangeCreateDto {
    if (!('record_id' in value) || value['record_id'] === undefined) return false;
    if (!('new_tax_year' in value) || value['new_tax_year'] === undefined) return false;
    return true;
}

export function IRecordTaxYearChangeCreateDtoFromJSON(json: any): IRecordTaxYearChangeCreateDto {
    return IRecordTaxYearChangeCreateDtoFromJSONTyped(json, false);
}

export function IRecordTaxYearChangeCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRecordTaxYearChangeCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'record_id': json['record_id'],
        'new_tax_year': json['new_tax_year'],
    };
}

export function IRecordTaxYearChangeCreateDtoToJSON(json: any): IRecordTaxYearChangeCreateDto {
    return IRecordTaxYearChangeCreateDtoToJSONTyped(json, false);
}

export function IRecordTaxYearChangeCreateDtoToJSONTyped(value?: IRecordTaxYearChangeCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'record_id': value['record_id'],
        'new_tax_year': value['new_tax_year'],
    };
}

